export const MAX_COLUMN_WIDTH = 1170;
export const FREE_RESIZE_SNAP_THRESHOLD = 10;
export const SLUG = 'ws-column';
export const FLEX_BASIS_PROPERTY = 'flex-basis';
export const FLEX_GROW_PROPERTY = 'flex-grow';
export const COLUMN_WIDTH_CUSTOM_CSS_PROPERTY = '--ws-column-width';
export const COLUMNS_COUNT = 12;
